import styled from 'styled-components';
import { motion } from "framer-motion"

const FormWrapper = styled(motion.div)`
    margin-bottom:10px;
`;

export default FormWrapper